export const LogoMark = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="48" height="48" rx="10" fill="#0A0A0A" />
    <rect x="1" y="1" width="46" height="46" rx="9" fill="none" stroke="#F95738" strokeWidth="2" />
    <path
      d="M17 35V13h8.5a6.5 6.5 0 0 1 0 13H17"
      fill="none"
      stroke="#F7F7F7"
      strokeWidth="4"
      strokeLinecap="square"
    />
    <path d="M15 39h18" stroke="#F95738" strokeWidth="3" strokeLinecap="square" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display text-lg tracking-tight text-coal" style={{ fontWeight: 800 }}>
        PETROLINE
      </span>
      <span className="block text-[10px] font-medium uppercase tracking-[0.35em] text-mist">
        Services
      </span>
    </span>
  </span>
);
